import { AnimatePresence } from 'framer-motion';
import React, { lazy, Suspense, useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import AppFooter from './components/shared/AppFooter';
import AppHeader from './components/shared/AppHeader';
import { FcAbout, FcBusinessman, FcCamera, FcFullTrash } from "react-icons/fc"
import './css/App.css';
import UseScrollToTop from './hooks/useScrollToTop';
import Fab from './components/reusable/FabComponent';
import ModalVideo from 'react-modal-video';
import Modal from './components/reusable/modalVideo';



const actions = [
	{ label: "About", icon: <FcAbout />, onClick: console.log },
	{ label: "Profile", icon: <FcBusinessman />, onClick: console.log },
	{ label: "Picture", icon: <FcCamera />, onClick: console.log },
	{ label: "Trash", icon: <FcFullTrash />, onClick: console.log },
  ];

const About = lazy(() => import('./pages/AboutMe'));
const Contact = lazy(() => import('./pages/Contact.jsx'));
const Home = lazy(() => import('./pages/Home'));
const Projects = lazy(() => import('./pages/Projects'));
const ProjectSingle = lazy(() => import('./pages/ProjectSingle.jsx'));

function App() {
	const [ isOpen, setOpen, collapsed, isShowing, setState] = useState(false);

	const toggle = () => {
		setState(collapsed => !collapsed);
	}

	useEffect(() => {
		console.log(isOpen); // This will reflect the updated state
	}, [isOpen]);

	return (
		<AnimatePresence>
			<div className=" bg-secondary-light dark:bg-primary-dark transition duration-300">
				<Router>
					<ScrollToTop />
					<AppHeader />
					<Modal
							channel="youtube"
							youtube={{ mute: 0, autoplay: 0 }}
							isOpen={isOpen}
							videoId="L61p2uyiMSo"
							onClose={() => setOpen(false)} 
					/>
					<Suspense fallback={""}>
						<Routes>
							<Route path="/" element={<Home />} />
							<Route path="projects" element={<Projects />} />
							<Route
								path="projects/single-project"
								element={<ProjectSingle />}
							/>

							<Route path="about" element={<About />} />
							<Route path="contact" element={<Contact />} />
						</Routes>
					</Suspense>
					<AppFooter />
				</Router>
				<button onClick={toggle} >
					<Fab/>
				</button>
				<UseScrollToTop />
			</div>
		</AnimatePresence>
	);
}

export default App;
